export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.741af1c3.worker.js");
}
